import { FC } from "react";

interface TargetIconSVGProps {
    className?: string;
}

const TargetIconSVG: FC<TargetIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.66699 16.0003H6.66699M6.66699 16.0003C6.66699 21.155 10.8457 25.3337 16.0003 25.3337M6.66699 16.0003C6.66699 10.8457 10.8457 6.66699 16.0003 6.66699M25.3337 16.0003H29.3337M25.3337 16.0003C25.3337 21.155 21.155 25.3337 16.0003 25.3337M25.3337 16.0003C25.3337 10.8457 21.155 6.66699 16.0003 6.66699M16.0003 2.66699V6.66699M16.0003 25.3337V29.3337"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TargetIconSVG;
